module.exports = __webpack_public_path__ + "static/media/palco_historias.05225525.webp";